import styles from '@/components/book/Mark.module.css';
import { emitIntent } from '@/lib/intents';

const MARKS = {
  star: { glyph: '★', label: 'starred' },
  new: { glyph: '†', label: 'filed this month' },
} as const;

/** ★ or † after a document title. Pressing it opens the Keys dialog, which explains it. */
export function Mark({ kind }: { kind: keyof typeof MARKS }) {
  const { glyph, label } = MARKS[kind];
  return (
    <button type="button" className={styles.mark} aria-label={label} title={label} onClick={() => emitIntent('open-keys')}>
      {glyph}
    </button>
  );
}
